export default __webpack_public_path__ + "static/media/download.e70b7512.png";